import React from "react";
import {SidebarNav} from "@/components/ui/sidebar-nav.tsx";
import {PageTitle} from "@/components/ui/headings";
import {pathToCriterionName} from "@/utils/criteria-helper.tsx";
import {useTranslation} from "react-i18next";

const sidebarNavItems = [
  ...Object.entries(pathToCriterionName).map(([path, title]) => ({
    title,
    href: `/match-criteria/${path}`
  })),
  { title: "affinityGroup", href: "/match-criteria/affinity-groups" }
];

interface MatchCriteriaLayoutProps {
  children: React.ReactNode;
}

export default function MatchCriteriaLayout({ children }: MatchCriteriaLayoutProps) {
  const {t} = useTranslation();

  return (
    <div className="container max-w-7xl py-12">
      <div className="space-y-6">
        <div className="space-y-2">
          <PageTitle>{t("criteria.matchCriteria")}</PageTitle>
          <p className="text-sm text-text-2">
            {t("criteria.manageCriteriaDesc")}
          </p>
        </div>
        <div className="flex flex-col gap-6 lg:flex-row lg:gap-8">
          <aside className="lg:w-64 shrink-0">
            <SidebarNav items={sidebarNavItems} />
          </aside>
          <div className="flex-1 min-w-0">{children}</div>
        </div>
      </div>
    </div>
  );
}
